import { Box, FlexLayout, GridLayout } from '@deity/falcon-ui';
import { mapRecordToArray } from '@deity-io/di-data-basics';
import type { IRestEndpointConfig } from '@deity-io/di-data-flows';
import type { FC } from 'react';

interface IEndpointDetails {
  locked?: boolean;
  schema: IRestEndpointConfig;
}

const EndpointDetails: FC<IEndpointDetails> = ({ locked = false, schema }) => {
  if (!schema) {
    return null;
  }

  const vars = mapRecordToArray(schema.variables, (item, key) => `${key}=${item}`);
  const path = vars.length ? `${schema.path}?${vars.join('&')}` : `${schema.path}`;

  return (
    <FlexLayout width="full">
      <GridLayout gridTemplateColumns="1fr 1fr" width="full">
        <Box>{schema.method}</Box>
        <Box>{`${schema.protocol}://${schema.host}`}</Box>
        <Box>Path</Box>
        <Box css={{ wordWrap: 'break-word' }}>{path}</Box>
      </GridLayout>
    </FlexLayout>
  );
};

export default EndpointDetails;
